var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3798_14889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16654 4.88186C6.16654 7.43459 4.13745 9.46368 1.58472 9.46368C4.13745 9.46368 6.16654 11.4928 6.16654 14.0455C6.16654 11.4928 8.19563 9.46368 10.7484 9.46368C8.19563 9.46368 6.16654 7.43459 6.16654 4.88186ZM11.4029 3.57277C11.4029 5.01277 10.2247 6.19095 8.78472 6.19095C10.2247 6.19095 11.4029 7.36913 11.4029 8.80913C11.4029 7.36913 12.5811 6.19095 14.0211 6.19095C12.5811 6.19095 11.4029 5.01277 11.4029 3.57277ZM3.54836 6.19095C3.54836 4.75095 4.72654 3.57277 6.16654 3.57277C4.72654 3.57277 3.54836 2.39459 3.54836 0.95459C3.54836 2.39459 2.37018 3.57277 0.930176 3.57277C2.37018 3.57277 3.54836 4.75095 3.54836 6.19095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3798_14889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0909,
    height: 13.0909,
    fill: "white",
    transform: "translate(0.930176 0.95459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a8db863d6da8b951b21576f9c3fbfd3c.svg";
export { ForwardRef as ReactComponent };